<template>
  <div>
    <div>
      <div class="headCont">
        <div class="addBox dis-cent">
          <div class="text">人才收藏列表</div>
        </div>
        <div class="slelectCont">
          <!-- <div class="ssBox">
            <input
              type="text"
              placeholder="搜索"
              v-model="searChTxt"
              @keyup.enter="searchClick"
            />
            <div
              class="iconfont icon-search search dis-cent"
              @click="searchClick"
            ></div>
          </div> -->
          <!-- <div class="lxBox dis-cent">
          <div class="name">全部职位类型</div>
          <div class="iconfont icon-unfold unfold"></div>
        </div> -->
        </div>
      </div>
      <div class="content">
        <Kong v-if="list.length == 0" />
        <PeoList :list="list" />
        <div class="fenye" v-if="totalCount > 6">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="6"
            @change="pageOnChange"
          />
        </div>
      </div>
    </div>
    <Jianli v-if="jlShow" :id="peoId" @show="jlShowJs" />
    <Dianping v-if="dianpingShow" @show="dpDelClick" :id="peoId" />
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  message,
} from "ant-design-vue";
import LoginZj from "../../component/loginZj.vue";
import Jianli from "../../component/jianli.vue";
import html2pdf from "html2pdf.js";
import Kong from "../../component/kong.vue";
import Dianping from "../../component/dianping.vue";
import PeoList from "../../component/peoList.vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    LoginZj,
    Jianli,
    Kong,
    Dianping,
    PeoList,
  },
  name: "",
  data() {
    return {
      daysNum: 0,
      dianpingShow: false,
      shang: "",
      searChTxt: "",
      typeOn: 0,
      typeList: [
        {
          id: "",
          name: "推荐",
        },
        {
          id: "a.create_time desc",
          name: "新人才",
        },
      ],
      xzList: [],
      jlShow: false,
      xzKey: "选择推荐岗位",
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 6,
      },
      list: [],
      totalCount: 0,
      category_id: "",
      category_cn: "选择推荐岗位",
      peoId: "",
    };
  },
  created() {
    this.listGet();
    this.vipGet();
  },
  methods: {
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    vipGet() {
      this.$get("/nozzle/web/company_vip").then((res) => {
        console.log(res);
        let startDate = this.$moment().format();
        let dateTimeStamp = this.$moment(res.vip.endtime * 1000).format();
        dateTimeStamp = this.$moment(dateTimeStamp);
        this.daysNum = dateTimeStamp.diff(startDate, "days");
        console.log(this.daysNum);
      });
    },
    dpClick(id) {
      this.peoId = id;
      this.dianpingShow = true;
    },
    dpDelClick(id) {
      this.dianpingShow = false;
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/company_favorite", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          // const currentYear = new Date().getFullYear();
          // for (let i = 0; i < res.data.length; i++) {
          //   const e = res.data[i];
          //   if (e.member.member_info.birthday) {
          //     e.age = currentYear - Number(e.member.member_info.birthday);
          //   }
          // }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    hyClick(e) {
      this.xzKey = e.key;
    },
    jlShowJs() {
      this.jlShow = false;
      this.canScroll();
    },
    scClick(id) {
      this.$post("/nozzle/web/favorite_save", {
        id: id,
        genre: 3,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.page.pageNo = 1;
          this.totalCount = 0;
          this.listGet();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    messageClick(id) {
      this.$post("/chat/chat_begin", {
        id: id,
        user_type: 2,
      }).then((res) => {
        // console.log(res);
        if (res.data.status == 1) {
          this.$router.push({
            path: "/gongsi/message",
            query: {
              id,
            },
          });
          // window.open("#/gongsi/message?id=" + id);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    jump(id, item) {
      this.peoId = id;
      console.log(item);

      this.jlShow = true;
      this.stopScroll();
    },
    //禁止滚动
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    xzClick(i) {
      this.xzList.splice(i, 1);
    },
    delClick() {
      this.xzList = [];
    },
    searchClick() {
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.headCont {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  margin-top: 10px;
  padding-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  max-width: 1280px;
  .addBox {
    display: flex;
    align-items: center;
    height: 35px;
    width: 110px;
    border-radius: 5px;
    background-color: #1a78ec;
    color: #fff;
    padding-right: 5px;
    cursor: pointer;

    .icon-add {
      font-weight: 600;
    }

    .text {
      margin-left: 5px;
    }
  }

  .slelectCont {
    display: flex;
    align-items: center;

    .ssBox {
      height: 35px;
      background-color: #fff;
      width: 260px;
      border-radius: 5px;
      display: flex;

      input {
        width: calc(100% - 35px);
        box-sizing: border-box;
        padding-left: 15px;
      }

      .search {
        width: 35px;
        height: 35px;
        color: #9c9c9c;
        font-size: 18px;
      }
    }

    .lxBox {
      margin-left: 20px;
      height: 35px;
      width: 140px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      color: #666;

      .unfold {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}

.content {
  width: 100%;
  margin: auto;
  max-width: 1280px;

  .cont {
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
    background-color: #fff;
    padding: 15px 20px;
    margin-bottom: 15px;
    display: flex;

    .contLeft {
      width: 60px;

      .imgBox {
        width: 60px;

        .img {
          height: 60px;
          width: 60px;
          border-radius: 50%;

          img {
            border-radius: 50%;
          }
        }

        .money {
          width: 60px;
          height: 20px;
          border-radius: 20px;
          background-color: #f34e1c;
          color: #fff;
          margin-top: 10px;
          font-size: 12px;
          font-weight: 600;
        }
      }
    }

    .contRit {
      width: calc(45% - 60px);
      padding-left: 25px;
      box-sizing: border-box;
      padding-right: 25px;

      .name {
        font-weight: 500;
        font-size: 16px;
      }

      .txtBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;

        .shu {
          width: 1px;
          height: 13px;
          background-color: #c9c9c9;
          margin: 0 8px;
        }

        .shu:last-child {
          display: none;
        }
      }

      .textBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;

        .txt {
          color: #999;
          width: 35px;
        }

        .text {
          width: calc(100% - 35px);
        }

        .texts {
          display: flex;
          align-items: center;
          width: calc(100% - 35px);

          .yuan {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #c9c9c9;
            margin: 0 6px;
          }
        }
      }

      .typeBox {
        display: flex;
        margin-top: 10px;

        .txt {
          padding: 3px 6px;
          background-color: #f0f3f7;
          margin-right: 10px;
          border-radius: 5px;
          color: #333;
          font-size: 12px;
        }
      }
    }

    .contJl {
      width: calc(55% - 80px);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .lcLi {
        display: flex;
        width: 100%;
        font-size: 13px;

        .iconBox {
          width: 22px;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: #b4b4b4;

          .icon {
            width: 16px;
            height: 20px;
            overflow: hidden;
          }

          .shu {
            border-left: 1px dashed #dadada;
            width: 1px;
            height: calc(100% - 20px);
          }

          .xuexiao {
            font-size: 19px;
            position: relative;
            top: -5px;
            left: -1px;
          }

          .liepinqiuzhi {
            font-size: 14px;
            position: relative;
            left: 1px;
          }
        }

        .boxs {
          width: calc(100% - 22px);

          .box {
            padding-left: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-bottom: 5px;

            .time {
              width: 130px;
              color: #9c9c9c;
            }

            .textBox {
              width: calc(100% - 130px);
              display: flex;
              align-items: center;

              .yuan {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #c9c9c9;
                margin: 0 10px;
              }
            }
          }
        }
      }
    }

    .goutong {
      width: 80px;

      .box {
        height: 40px;
        background-color: #147ee0;
        color: #fff;
        border-radius: 5px;
      }

      .csbox {
        background-color: #c90e0e;
        color: #fff;
        height: 40px;
        border-radius: 5px;
        margin-top: 10px;
      }
    }
  }
  .anse {
    color: #999;
  }
}
</style>
